import { Component } from '@angular/core';
import { PropietarioService } from '../../../../shared/services/propietarios.service';
import { VehiclesService } from '../../../../shared/services/vehicles.service';

@Component({
  selector: 'app-grafico-personas',
  templateUrl: './grafico-personas.component.html',
  styleUrls: ['./grafico-personas.component.scss']
})
export class GraficoPersonasComponent {

  
  public personaActiva = {
    icon: "customers",
    counter: "0",
    name: "Personas Activas",
    font: "success",
    pr: "0",
  };

  public personaInactiva = {
    icon: "customers",
    counter: "0",
    name: "Personas Inactivas",
    font: "secondary",
    pr: "0",
  };

  public personaTotal = {
    icon: "customers",
    counter: "0",
    name: "Total Personas",
    font: "primary",
    pr: "0",
  };



 vehActivos={
  icon: "icon-bus",
  counter: "0",
  name: "Vehículos Activos",
  font: "success",
  pr: "0",
}
 vehInactivos={
  icon: "icon-bus",
  counter: "0",
  name: "Vehículos Inactivos",
  font: "secondary",
  pr: "0",
}

 vehTotal={
  icon: "icon-bus",
  counter: "0",
  name: "Total Vehículos",
  font: "primary",
  pr: "0",
}


  constructor(
    public propietarioService: PropietarioService,
    public vehiculoService: VehiclesService
  ) {}

  ngOnInit() {
  this.conteoPropietarios();
  this.conteoVehiculos();
}

private conteoPropietarios() {
  this.propietarioService.getContarPropietarios().subscribe(data => {
    this.personaActiva.counter   = data.activos.toString();
    this.personaInactiva.counter = data.inactivos.toString();
    this.personaTotal.counter    = data.total.toString();

    if (data.total > 0) {
      this.personaActiva.pr   = ((data.activos / data.total) * 100).toFixed(0);
      this.personaInactiva.pr = ((data.inactivos / data.total) * 100).toFixed(0);
      this.personaTotal.pr    = "100";
    }
  });
}

private conteoVehiculos() {
  this.vehiculoService.getContarVehiculos().subscribe(data => {
    this.vehActivos.counter   = data.activos.toString();
    this.vehInactivos.counter = data.inactivos.toString();
    this.vehTotal.counter     = data.total.toString();

    if (data.total > 0) {
      this.vehActivos.pr   = ((data.activos / data.total) * 100).toFixed(0);
      this.vehInactivos.pr = ((data.inactivos / data.total) * 100).toFixed(0);
      this.vehTotal.pr     = "100"; // 👈 corregido
    }
  });
}

}
